import { WEBSITE_TUNNEL_TYPES } from "app/constants";
import { fetchSDPFilters } from "app/pages/SmartDP/smartDPActionCreators";
import { fetchHotelOnlySearchFormAvailability } from "app/pages/HotelOnly/hotelOnlyActionCreator";

const SDP_FILTERS_TUNNEL_TYPES = [WEBSITE_TUNNEL_TYPES.HOLIDAYS, WEBSITE_TUNNEL_TYPES.STOPOVER];

// smartDP ne garde les filtres que d'un tunnel à la fois : charger ceux d'un onglet inactif
// écraserait les destinations et les cabines de l'onglet affiché.
export const fetchTunnelSearchFilters = ({ websiteTunnelType, ...params }) => {
	if (SDP_FILTERS_TUNNEL_TYPES.includes(websiteTunnelType)) {
		return fetchSDPFilters(params);
	}

	if (websiteTunnelType === WEBSITE_TUNNEL_TYPES.HOTEL_ONLY) {
		return fetchHotelOnlySearchFormAvailability(params);
	}

	return undefined;
};

// Pour le SSR de la home : WebsiteTunnelSwitcher affiche le premier tunnel au premier rendu.
export const fetchDefaultTunnelSearchFilters = ({ websiteTunnels, ...params }) =>
	fetchTunnelSearchFilters({
		...params,
		websiteTunnelType: websiteTunnels?.[0]?.websiteTunnelType,
	});
